<template>
  <div class="ui modal">
    <div class="ui inverted dimmer" v-bind:class="{ active: processing }">
      <div class="ui text double slow blue loader">{{ $t("loading") }}</div>
    </div>
    <i class="close icon"></i>
    <div class="icon header">
      <i class="settings icon"></i>
      {{ $t("ngine core configuration") }}
    </div>
    <div class="image content">
      <div class="ui small image">
        <img src="/images/icons/ngine_logo.png" />
      </div>
      <div class="description">
        <generic-container
          :title="$t('partitions')"
          icon="layer group"
          :show_plus="true"
          v-on:add="add"
        >
          <div class="ui selection divided list">
            <div
              class="item"
              v-for="(partition, index) in partitions"
              :key="index"
              @click="edit(partition)"
            >
              <i class="layer group icon"></i>
              <div class="content">
                <a class="header">{{ partition.name }}</a>
              </div>
            </div>
          </div>
        </generic-container>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, toast } from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import { error_toast } from "../../utils";

export default {
  components: {
    GenericContainer
  },
  computed: {},
  data() {
    return {
      processing: false,
      partitions: [],
      all_partitions: []
    };
  },
  methods: {
    add() {
      let vm = this;
      vm.$alertify.prompt(vm.$t("partition name"), "", function(evt, val) {
        local_api(vm, "post", "/ngine_core/partition/do-save", {
          n: val
        })
          .then(partition => {
            vm.partitions.push(partition);
          })
          .catch(err => {
            error_toast(err);
          });
      });
    },
    remove(partition, index) {
      this.partitions.splice(index, 1);
    },
    edit(partition, index) {
      let vm = this;
      vm.$alertify.prompt(vm.$t("partition name"), partition.name, function(
        evt,
        val
      ) {
        local_api(vm, "post", "/ngine_core/partition/do-save", {
          n: val,
          i: partition.uuid
        })
          .then(partition => {
            vm.partitions.splice(index, 1, partition);
          })
          .catch(err => {
            error_toast(err);
          });
      });
    }
  },
  mounted() {
    let vm = this;
    local_api(this, "post", "/ngine_core/partition/do-get-list")
      .then(partitions => {
        vm.partitions = partitions;
      })
      .catch(err => {
        toast(this.$el, "error", err);
      });

    window
      .jQuery(vm.$el)
      .modal({
        onShow() {},
        onVisible() {},
        onHidden() {
          vm.$destroy();
        }
      })
      .modal("show");
  },
  watch: {},
  updated: function() {
    let vm = this;
    this.$nextTick(function() {
      window.jQuery(this.$refs.type).dropdown({
        onChange(value) {
          let index = window.jQuery(this).data("index");
          vm.attributes[index].type = value;
        }
      });
    });
  }
};
</script>
